import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import SiteActivation from "@/components/signup/site-activation";
import { getFirstName } from "@/components/signup/utils";

import { useSiteNameContext } from "../../site-name-form/site-name-context";

const containerStyles = css({
    background: "white",
    borderRadius: "20px",
    padding: "40px 50px 56px",
    width: "468px"
});

const headerStyles = css({
    fontWeight: 500
});

export const LoggedInForm = () => {
    const intl = useIntl();

    const {
        userInfo: { name }
    } = useSiteNameContext();

    const headerText = intl.formatMessage(
        {
            id: "BxpUiSignup.nameSite.header",
            defaultMessage: "Welcome back, {name}"
        },
        {
            name: getFirstName(name)
        }
    );

    return (
        <div css={containerStyles}>
            <h1 css={headerStyles}>{headerText}</h1>
            <SiteActivation WeekOneUser={null} />
        </div>
    );
};
